import React from "react";

import useTogglePswVisibility from "../../Pages/Auth/hooks/useTogglePswVisibility";
import { PASSWORD_TYPE } from "../../Pages/Auth/types";
import InputField from "./InputField";

interface MaskedPasswordInputProps<FieldName extends string> {
  [key: string]: any;
  name: FieldName;
  value: string;
  handleChange: (field: FieldName, value: string) => void;
  handleBlur: (field: FieldName, value: string) => void;
  errorText?: string;
  disabled?: boolean;
}

const MaskedPasswordInput = <FieldName extends string>({
  name,
  value,
  handleChange,
  handleBlur,
  errorText,
  disabled,
  ...props
}: MaskedPasswordInputProps<FieldName>) => {
  const { showPassword, PasswordVisibility } = useTogglePswVisibility(
    PASSWORD_TYPE.Current
  );

  const handleClipboard = (e: React.ClipboardEvent<HTMLInputElement>) => {
    if (!showPassword.current) e.preventDefault();
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    if (showPassword.current) {
      handleChange(name, inputValue);
    } else {
      const newValue = inputValue.replace(/•/g, (_, i) => value[i] || "");

      handleChange(name, newValue);
    }
  };

  const displayValue = showPassword.current ? value : "•".repeat(value.length);

  return (
    <InputField
      {...props}
      size="medium"
      type="text"
      name={name}
      value={displayValue}
      onChange={handleInputChange}
      onBlur={() => handleBlur(name, value)}
      onCopy={handleClipboard}
      onCut={handleClipboard}
      errorText={errorText}
      disabled={disabled}
      slotProps={{
        input: {
          ...props.InputProps
        }
      }}
      iconRight={<PasswordVisibility />}
    />
  );
};

export default MaskedPasswordInput;
